// 事项服务仓库
const itemService = {
  state: {
    // 选择的事项id
    choiceItemId: ''
  },
  mutations: {
    // 存入事项id
    setItemId(state, itemId) {
      state.choiceItemId = itemId
    }
  }
}

// 导出模块
export default itemService
